export enum ProcessModelValidationSeverity {
  Error = "Error",
  Warn = "Warn",
  Hint = "Hint",
}
